var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15556 37.4H33.2444C34.3466 37.4 35.4035 36.9622 36.1829 36.1829C36.9622 35.4035 37.4 34.3466 37.4 33.2444V10.3889L27.0111 0H4.15556C3.05343 0 1.99645 0.437816 1.21713 1.21713C0.437816 1.99645 0 3.05343 0 4.15556V33.2444C0 34.3466 0.437816 35.4035 1.21713 36.1829C1.99645 36.9622 3.05343 37.4 4.15556 37.4ZM8.31111 4.15556H16.6222V8.31111H20.7778V4.15556H24.9333V12.4667H8.31111V4.15556ZM8.31111 20.7778H29.0889V33.2444H8.31111V20.7778Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/Icon_Save.8fb80ffa393199beb449ea8c18038d79.svg";
export { ForwardRef as ReactComponent };